import CityPageTemplate from "../city-template/CityPageTemplate";
import { belgradeConfig } from "./data";

export default function BelgradePage() {
  return <CityPageTemplate config={belgradeConfig} />;
}